import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from '@westwing/ui-kit/Theme';
import { AppShellProps } from '@ids/appshell/types';
import { AppShellProvider } from '@ids/appshell/context';
import CSSResets from '@ids/components/Layout/CSSResets';
import AppRouter from '@ids/router';
import { AppProvider } from '@ids/context/App';
import { OverwhelmedOverlayProvider } from '@ids/context/OverwhelmedOverlay';
import { CookiesProvider } from '@ids/context/Cookies';

const Main = ({ ...props }: AppShellProps) => {
    return (
        <ThemeProvider theme={theme}>
            <CSSResets />
            <AppShellProvider {...props}>
                <main data-testid="mf-interior-design-service">
                    <CookiesProvider>
                        <AppProvider>
                            <OverwhelmedOverlayProvider>
                                <AppRouter />
                            </OverwhelmedOverlayProvider>
                        </AppProvider>
                    </CookiesProvider>
                </main>
            </AppShellProvider>
        </ThemeProvider>
    );
};

export default Main;
